// extracted by mini-css-extract-plugin
module.exports = {"menu":"_1i-Rq","menu-hidden":"LZd-S","menuHidden":"LZd-S","option":"zDUjV","poweredByGoogleWrapper":"_2N8Ff","highlighted":"d2m8A"};